import {Player} from "@/models/Player";
import {Round} from "@/models/Round";
import {Type} from "class-transformer";

export class Game {
    private _numberOfPlayers: number;

    @Type(() => Player)
    private _players: Player[] = [];

    @Type(() => Round)
    private _rounds: Round[] = [];


    get numberOfPlayers(): number {
        return this._numberOfPlayers;
    }

    set numberOfPlayers(value: number) {
        this._numberOfPlayers = value;
    }

    get players(): Player[] {
        return this._players;
    }

    set players(value: Player[]) {
        this._players = value;
    }

    get rounds(): Round[] {
        return this._rounds;
    }

    set rounds(value: Round[]) {
        this._rounds = value;
    }
}